var React = require('react');
var PropTypes = React.PropTypes;
var Modal = require('react-bootstrap').Modal;
var Dropzone = require('react-dropzone');
var env = require("../../utils/env");
var mediaAPI = env.domain.mediaApi;
var api = env.domain.api;
var request = require('superagent');
import { requestPermission, uploadFile } from '../../resources/media'
import CircularProgress from 'material-ui/CircularProgress';
import '../../css/components/ImageUpload/iu.css';

var blobToFile = function(theBlob, fileName){
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

var toBase64 = function(files, callback){
	var done = 0;
  files.forEach(function(file, index) {
    var reader = new FileReader();
		reader.onloadend = function(){
			files[index].src = reader.result;
			done++;
			if (done === files.length){
				callback(files);
			}
		};
		reader.readAsDataURL(files[index]);
  })
};

var ImageUploader = React.createClass({
  openUploadModal: function() {
    this.setState({
      showModal: true,
      file: undefined
    })
  },
  closeModal: function() {
    this.setState({
			showModal: false,
			urlError: false
    })
  },

	submitUrl: function() {
		if (this.state.isSubmittingUrl) {
			return;
		}
		var _this = this;
		_this.setState({urlError: false, isSubmittingUrl: true});
		var url = this.refs['url'].value;
		var format = url.split(".")[url.split(".").length-1];
		var api = mediaAPI + '/v1/downloadImage';
		request
		.get(api)
		.query({url: url})
		.withCredentials()
		.then(function(response) {
			var src = response.body;
			if (src.data.substring(5,10) !== "image"){
				return _this.setState({urlError: true, isSubmittingUrl: false});
			}
			var newFile = {
				src: src.data,
				preview: src.data
			}
			// newFile = blobToFile(newFile, Date.now() + "." + format);
			// var xfile = new File([newFile], Date.now() + "." + format, {type: "image/png", lastModified: Date.now()});
			// xfile.src = src.data;
			// xfile.preview = src.data;
			// var fileName = Date.now() + "." + format;
			// var blob = b64toBlob(src.data, 'image/png');
			// var xfile = blobToFile(blob, fileName);
			var obj = src.data.split(',');
		  var type = obj[0].split(':')[1].split(';')[0];
		  var extension = type.split('/')[1];
			var fileName = Date.now() + "." + extension;
		  var blob = atob(obj[1]);
		  var array = [];
		  for(var i = 0; i < blob.length; i++) {
		    array.push(blob.charCodeAt(i));
		  };
		  var blob = new Blob([new Uint8Array(array)], {type: type});
			var xfile = blobToFile(blob, fileName);
			xfile.src = src.data;
			xfile.preview = src.data;
			_this.setState({file: xfile, isSubmittingUrl: false});
		}, function(err) {
			_this.setState({urlError: true, isSubmittingUrl: false});
		})
	},

	startUpload: function() {
		if (!this.props.remainModalWhenUpload) {
			this.setState({
				showModal: false
			})
		}
		this.setState({
			isUploading: true
		}, () => {
			var file = this.state.file;
			this.props.onUploading();
			uploadFile(file, (err, res) => {
				// this.props.onUploadDone(res);
				this.setState({showModal: false, isUploading: false}, () => {
					setTimeout(() => {
						this.props.onUploadDone(res);
					}, 500)
				})
			})
		})
	},

  onDropFile: function(files) {
    var _this = this;
    toBase64(files, function(files) {
      var file = files[0];
      _this.setState({
        file: file
      });
    })
  },

  getInitialState: function() {
    return {
      showModal: false
    };
  },

  render: function() {
    var _this = this;
    return (
      <div onClick={_this.openUploadModal} style={{"position": "relative"}}>
        {this.props.children}
        <Modal show={_this.state.showModal} onHide={_this.closeModal} backdrop={false} keyboard={false}>
          <Modal.Header>
            <Modal.Title>Upload Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Dropzone onDrop={this.onDropFile} accept={"image/*"} className="dropzone">
              {
                _this.state.file ?
                (
                  <div className="img-container">
                    <img style={{maxWidth: "100%"}} src={_this.state.file.preview} alt="Upload"/>
										{
											_this.state.isUploading &&
											<div className="intrinsic-item">
												<CircularProgress className="loading"/>
											</div>
										}
                  </div>
                ) : (
                  <div className="dropzone-container">
                    <i className="fa fa-cloud-upload icon"></i>
                    <p className="title">Drag images here</p>
                    <p className="sub">or click to browse file</p>
                  </div>
                )
              }
            </Dropzone>
						<div className={"input-group margin-top-10" + (_this.state.urlError ? " has-error" : " ")}>
							<input type="text" className="form-control" disabled={_this.state.isSubmittingUrl} ref="url" placeholder="Or upload image by URL"/>
							<span className="input-group-addon" style={{cursor: "pointer"}} onClick={_this.submitUrl}>Submit</span>
						</div>
						{
							_this.state.urlError &&
							<span className="text-danger margin-bottom-10"><small>Cannot use this URL. Please try again</small></span>
						}
						{
							_this.state.isSubmittingUrl && <div className="margin-top-10"><CircularProgress /></div>
						}
          </Modal.Body>
          <Modal.Footer>
						{
							_this.state.file &&
							<button
								disabled={_this.state.isUploading}
								className="btn btn-success"
								onClick={_this.startUpload}>Upload</button>
						}
						<button
							disabled={_this.state.isUploading}
							className="button"
							onClick={_this.closeModal}>Close</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

});

export default ImageUploader;



/** WEBPACK FOOTER **
 ** ./src/components/ImageUpload/ImageUploader.js
 **/